<template>
  <a-input-group
    style="width: 100%"
    size="small"
    compact
  >
    <a-input
      :style="inputStyle"
      readonly
      :value="value1.name"
      size="small"
    >
      <template #prefix>
        <component
          :is="value1.value"
          v-if="value1"
        />
      </template>
    </a-input>
    <a-button
      v-if="value1.name"
      size="small"
      @click="handleClear"
      style="border-radius: 0"
    >
      <template #icon>
        <CloseOutlined style="font-size: 12px; height: 9px" />
      </template>
    </a-button>
    <a-button
      size="small"
      @click="handleSearch"
      style="border-radius: 0 4px 4px 0"
    >
      <template #icon>
        <SearchOutlined style="font-size: 12px; height: 9px" />
      </template>
    </a-button>
  </a-input-group>
  <select-icon-modal
    v-model:open="showModal"
    v-model:value="value1"
    :icon_data="all_icons"
    @update:value="handleChange"
  />
</template>

<script lang="ts">
import { useExtraMenuIcons } from 'liyu-pc-base/init-plugin';
import { computed, defineComponent, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { icon_data } from './icons';
import SelectIconModal from './selectIconModal.vue';
export default defineComponent({
  name: 'IconSelect',
  components: {
    SelectIconModal,
  },
  props: {
    value: {
      type: [Array, Number, String],
      required: false,
      default: () => '123',
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  emits: ['update:value'],
  setup(props, { emit }) {
    const all_icons = [...useExtraMenuIcons(), ...icon_data];
    const findIcon = (value: string) => {
      const icon_group = all_icons.find(item => item.icons.some(icon => icon.value === value));
      return icon_group ? icon_group.icons.find(icon => icon.value === value) : null;
    };
    const value1 = ref({ name: '', value: '' });
    watch(
      () => props.value,
      () => {
        if (props.value) {
          const icon = findIcon(String(props.value));
          value1.value = icon || { name: '', value: '' };
        }
      },
      { immediate: true },
    );

    const { t } = useI18n();
    const showModal = ref(false);
    const handleChange = value => {
      emit('update:value', value.value);
      showModal.value = false;
    };
    const handleSearch = () => {
      // show modal
      showModal.value = true;
    };
    const handleClear = () => {
      value1.value = { name: '', value: '' };
      emit('update:value', '');
    };
    const inputStyle = computed(() => {
      if (value1.value.name) {
        return {
          width: 'calc(100% - 55px)',
        };
      }
      return {
        width: 'calc(100% - 32px)',
      };
    });
    return {
      props,
      t,
      value1,
      handleChange,
      showModal,
      handleSearch,
      handleClear,
      inputStyle,
      all_icons,
    };
  },
});
</script>
